import { render } from "./GameStateFinish.vue?vue&type=template&id=4223cd58&scoped=true"
import script from "./GameStateFinish.vue?vue&type=script&lang=js"
export * from "./GameStateFinish.vue?vue&type=script&lang=js"

import "./GameStateFinish.vue?vue&type=style&index=0&id=4223cd58&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4223cd58"]])

export default __exports__